<div style="padding: 5px;" *ngIf="partner.POSSystemID==9">
  <p-accordion>
    <p-accordionTab header="Need Help Getting Started">
      <p-accordion>
        <p-accordionTab header="Set up workshop technicians and working hours">
          <p style="font-size:14px;">
            Before you can book your first job in the calendar, technicians need to be setup. <br />
            You can do this by going to settings>users and ensuring you have at least one technician, with working
            hours. Check the help video <a href="https://help.hubtiger.com/article/51-creating-a-new-technician"
              target="_blank">here</a>.
          </p>
        </p-accordionTab>
        <p-accordionTab header="Set up service types">
          <p style="font-size:14px;">
            Great! <a href="https://help.hubtiger.com/article/49-creating-a-new-service-type" target="_blank">Here's</a>
            a short video with the steps to set up your workshop services and/or bike fitting services.
            <br />
            In settings>service types:

            <li> - Import your entire list or add them one by one</li>
            <li> - Configure how long each one takes.</li>
            <li> - Configure whether the service types should be displayed online.</li>
            <li> - Link a SKU, already created in your POS, so Hubtiger will automatically add that SKU to the quote
              when the service is booked.
            </li>
          </p>
        </p-accordionTab>
        <p-accordionTab header="Communicate with customers">
          <p style="font-size:14px;">
            Great! Our <a href="https://help.hubtiger.com/article/52-creating-an-email-template"
              target="_blank">help-video
              to communicating with customers</a> will have you sending your first automated message in no time!
          </p>
        </p-accordionTab>
        <p-accordionTab header="Schedule your first job card">
          <p style="font-size:14px;">
            First go to calendar, and click on a day that is free and create a service.<br />
            You can create a service by inputting at least name and mobile number, then click "create cyclist"<br />
            Select a service type then press "schedule"<br />
            Open the job card, you can click on anything including changing statuses to receive communication.
          </p>
        </p-accordionTab>
        <p-accordionTab header="Send to Shopify" *ngIf="partner.POSSystemID==9">
          <p style="font-size:14px;">
            In the job card, click on the quote tab. On the top right search for a product, you can add it by hitting
            enter.<br />
            Once you have a couple of products on the quote, you can send to Shopify.<br />
            Open Shopify account and go to Orders, the new order should be there.
          </p>
        </p-accordionTab>
      </p-accordion>
    </p-accordionTab>

  </p-accordion>
</div>


<div class="pl-4 mr-3">

  <div class="row   justify-content-start mb-2">
    <div class="col-9">
      <span class="iso-header ml-2">
        {{'bikeshop.menu.settings' | translate}}
      </span>
    </div>
    <div class="col-3 justify-content-end d-flex">
      <daz-icon class="iso-search-icon" [name]="'search'" [size]="'22px'" [color]="'#888888'"></daz-icon>
      <input (keyup)="searchSettings()" [(ngModel)]="searchTerm" class="iso-search-bar" type="text"
        placeholder="Search">

    </div>
  </div>
  <div class="row">
    <div *ngIf="general.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel [navigationItems]="general" [header]="'bikeshop.shop_setup.header.general'"
        [icon]="'settings-generel'">
      </app-menu-panel>
    </div>
    <div *ngIf="productsAndServices.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel [navigationItems]="productsAndServices" [header]="'Products'" [icon]="'box-archive'">
      </app-menu-panel>
    </div>
    <div *ngIf="services.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel [navigationItems]="services" [header]="'general.headers.services'" [icon]="'compass'">
      </app-menu-panel>
    </div>
    <div *ngIf="workflow.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <!--      todo: add translation-->
      <app-menu-panel [navigationItems]="workflow" [header]="'bikeshop.shop_setup.card_headers.workflow'"
        [icon]="'workflow'">
      </app-menu-panel>
    </div>
    <div *ngIf="payments.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel [navigationItems]="payments" [header]="'bikeshop.rentals.configuration.payment'"
        [icon]="'wallet'">
      </app-menu-panel>
    </div>
    <div *ngIf="messaging.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3  mb-1 p-1">
      <app-menu-panel [navigationItems]="messaging" [header]="'bikeshop.shop_setup.header.messaging'"
        [icon]="'message-circle'">
      </app-menu-panel>
    </div>
    <div *ngIf="plugins.length > 0" class="col-12	col-sm-6	col-md-6	col-lg-3	col-xl-3 mb-1 p-1">
      <app-menu-panel [navigationItems]="plugins" [header]="'Plugins'" [icon]="'browser'">
      </app-menu-panel>
    </div>
  </div>
  <div *ngIf="!checkIfSettings()" class="row">
    <div class="col-9">
      <span class="iso-info-text ml-2">
        {{ 'bikeshop.shop_setup.no_settings_found' | translate }}
      </span>
    </div>
  </div>

</div>

<!--<div style="padding: 16px;">-->
<!--  <div class="header">{{ "bikeshop.shop_setup.header.messaging" | translate }}</div>-->
<!--  <app-menu-card [navigationItems]="messaging">-->
<!--  </app-menu-card>-->
<!--  <div class="header">{{ "bikeshop.shop_setup.header.products_and_services" | translate }}</div>-->
<!--  <app-menu-card [navigationItems]="productsAndServices">-->
<!--  </app-menu-card>-->
<!--  <div class="header">{{ "bikeshop.shop_setup.header.general" | translate }}</div>-->
<!--  <app-menu-card [navigationItems]="general">-->
<!--  </app-menu-card>-->
<!--  <div class="header">Plugins</div>-->
<!--  <app-menu-card [navigationItems]="plugins">-->
<!--  </app-menu-card>-->
<!--</div>-->